import { PlanoInternet } from "../../class/index";
export default {
    data() {
        return {
            user: null,
            cliente: {}
        };
    },
    methods: {
        loadPonto() {
            if (this.$route.params.id) {
                PlanoInternet.byID(this.$route.params.id)
                    .then(row => this.$store.commit("setPlanoInternet", row))
                    .catch(() =>
                        this.$store.commit(
                            "setPlanoInternet",
                            PlanoInternet.create()
                        )
                    );
            }
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadPonto(this.$route.params.id);
        } else {
            this.$store.commit("setPlanoInternet", PlanoInternet.create());
        }
    }
};
